<template>
  <b-container fluid>
    <h3>Items</h3>
    <hr />
    <b-row>
      <b-col class="d-flex justify-content-start">
        <b-button variant="blue" @click="addItem" size="sm">
          <b-icon-plus />
          Add Item
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="!selectedItem">
      <b-col :md="6">
        <b-radio-group class="mt-2" v-model="showActive">
          <b-radio :value="true">Active Items</b-radio>
          <b-radio :value="false">Inactive Items</b-radio>
        </b-radio-group>
      </b-col>
      <b-col :md="5">
        <b-form-group
          label="Category Filter:"
          :label-cols="4"
          label-align="right"
        >
          <b-select
            :options="categories"
            :value="null"
            @change="onFilterSelect"
            text-field="name"
            value-field="id"
          >
            <template #first>
              <b-select-option :value="null">All</b-select-option>
            </template>
          </b-select>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <!-- Items Grid -->
      <b-col v-if="!selectedItem">
        <dx-data-grid
          :data-source="items"
          :selection="gridSettings.selection"
          :columns="gridFields"
          :allowColumnResizing="true"
          :group-panel="gridSettings.groupPanel"
          :header-filter="gridSettings.headerFilter"
          :filter-row="gridSettings.filterRow"
          :pager="gridSettings.pager"
          :paging="gridSettings.paging"
          :height="725"
          :onRowDblClick="onSelection"
          :onRowRemoving="onRemovingItem"
          :onCellPrepared="onCellPrep"
          :editing="gridSettings.editing"
          :loadPanel="{ enabled: true, showPane: true }"
          ref="grd"
        >
          <!-- <dx-load-panel :visible.sync="isLoading" /> -->
        </dx-data-grid>
      </b-col>
      <!-- Edit Window -->
      <b-col v-else>
        <b-overlay :show="submitting">
          <template v-slot:overlay>
            <div class="text-center">
              <b-icon-stopwatch
                font-scale="3"
                animation="cylon"
              ></b-icon-stopwatch>
              <p id="cancel-label">Saving, please wait...</p>
            </div>
          </template>
          <b-form
            :class="{
              'needs-validation': !submitted,
              'was-validated': submitted
            }"
            @submit.stop.prevent="onSubmit"
            novalidate
          >
            <b-container fluid>
              <h5>Item Basics</h5>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Item Name:"
                    :label-cols="2"
                    label-align="right"
                    label-for="name"
                  >
                    <b-form-invalid-feedback :state="validationStat.name.state">
                      {{ validationStat.name.msg }}
                    </b-form-invalid-feedback>
                    <b-input
                      type="text"
                      v-model="selectedItem.name"
                      placeholder="Item name"
                      @blur="onBlur('name', $event.target)"
                      required
                      :maxlength="255"
                      autofocus
                      autocomplete="off"
                      ref="name"
                      id="name"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Part Number:"
                    :label-cols="2"
                    label-align="right"
                    label-for="pn"
                  >
                    <b-input
                      type="text"
                      v-model="selectedItem.part_number"
                      :maxlength="255"
                      placeholder="Part number"
                      id="pn"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Part Code:"
                    :label-cols="2"
                    label-align="right"
                    label-for="pc"
                  >
                    <b-input
                      type="text"
                      v-model="selectedItem.product_code"
                      :maxlength="255"
                      placeholder="Product code"
                      id="pc"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Status:"
                    :label-cols="2"
                    label-align="right"
                    label-for="pc"
                  >
                    <b-radio-group
                      class="mt-2"
                      v-model="selectedItem.is_active"
                    >
                      <b-radio name="stat" :value="1">Active</b-radio>
                      <b-radio name="stat" :value="0">Inactive</b-radio>
                    </b-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
              <h5>Additional Information</h5>
              <b-row>
                <b-col>
                  <!-- <b-select
                  :options="categories"
                  v-model="selectedItem.item_category_id"
                  value-field="id"
                  text-field="name"
                  @blur="onBlur('cat', $event.target)"
                  required
                  ref="cat"
                >
                  <template #first>
                    <b-select-option :value="null" disabled
                      >Please select an item category</b-select-option
                    >
                  </template>
                </b-select>

                <b-checkbox
                  @change="setBackorder"
                  :checked="selectedItem.is_backordered === 1"
                >
                  Item is in back order
                </b-checkbox> -->

                  <b-form-group
                    label="Category:"
                    :label-cols="2"
                    label-align="right"
                    label-for="name"
                  >
                    <b-input-group>
                      <b-select
                        :options="categories"
                        v-model="selectedItem.item_category_id"
                        value-field="id"
                        text-field="name"
                        required
                        ref="cat"
                      >
                        <template #first>
                          <b-select-option :value="null" disabled>
                            Please select an item category
                          </b-select-option>
                        </template>
                      </b-select>
                      <b-input-group-append is-text>
                        <b-checkbox
                          @change="setBackorder"
                          :checked="selectedItem.is_backordered === 1"
                        >
                          Item is in back order
                        </b-checkbox>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- <b-col align-self="center" :md="3">
                <b-checkbox
                  @change="setBackorder"
                  :checked="selectedItem.is_backordered === 1"
                >
                  Item is in back order
                </b-checkbox>
              </b-col> -->
              </b-row>
              <b-row>
                <b-col>
                  <!-- <b-form-invalid-feedback
                      :state="validationStat.backDate.state"
                    >
                      {{ validationStat.backDate.msg }}
                    </b-form-invalid-feedback> -->
                  <b-form-group
                    label="Expected on:"
                    :label-cols="2"
                    label-align="right"
                    label-for="name"
                    v-if="selectedItem.is_backordered === 1"
                  >
                    <b-input
                      type="date"
                      :value="backOrderDate"
                      @blur="setDate"
                      required
                      ref="backDate"
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col :md="3">
                <b-form-group
                  :label-cols="2"
                  label-align="right"
                  label-for="name"
                >
                  <b-checkbox
                    @change="setBackorder"
                    :checked="selectedItem.is_backordered === 1"
                  >
                    Item is in back order
                  </b-checkbox>
                </b-form-group>
              </b-col> -->
              </b-row>
              <hr />
            </b-container>
            <b-button type="submit" variant="primary" style="width:125px;">
              Save Changes
            </b-button>
            <b-button variant="danger" @click="onCancel" style="width:125px;">
              Cancel
            </b-button>
          </b-form>
        </b-overlay>
      </b-col>
    </b-row>
    <!-- <load-panel :display="isLoading" /> -->
  </b-container>
</template>

<script>
// import { DxDataGrid } from "devextreme-vue/data-grid";
import LoadPanel from "../LoadPanel";

export default {
  components: {
    // DxDataGrid,
    LoadPanel
  },
  data() {
    return {
      selectedItem: null,
      _status: false,
      isNewItem: false,
      submitted: false,
      submitting: false,
      validationStat: {
        name: {
          state: null,
          msg: ""
        },
        cat: {
          state: null,
          msg: ""
        },
        backDate: {
          state: null,
          msg: ""
        }
      },
      gridFields: [
        {
          dataField: "name",
          sortOrder: "asc"
        },
        {
          dataField: "part_number",
          width: 250
        },
        {
          dataField: "item_category_id",
          // groupIndex: 0,
          // autoExpandGroup: false,
          caption: "Category",
          calculateDisplayValue: this.categoryDisplay,
          width: 250,
          alignment: "left"
        }
      ],
      gridSettings: {
        selection: {
          mode: "single"
        },
        editing: {
          allowDeleting: true,
          useIcons: true
        },
        groupPanel: {
          visible: false,
          allowColumnDragging: false
        },
        headerFilter: {
          allowSearch: true,
          visible: true
        },
        filterRow: {
          visible: true
        },
        pager: {
          showPageSizeSelector: true,
          showInfo: true,
          allowedPageSizes: [25, 50, 100]
        },
        paging: {
          pageSize: 25
        }
      }
    };
  },
  beforeMount() {
    debugger;
    return this.$store.dispatch("sysItems/getItems");
  },
  computed: {
    showActive: {
      get() {
        var rsl = this.$store.getters["sysItems/showActive"];
        debugger;
        return rsl;
      },
      set(val) {
        debugger;
        return this.$store.dispatch("sysItems/loadInactive", val).then(() => {
          return this.$store.dispatch("sysItems/getItems");
        });
      }
    },
    isLoading() {
      var stat = this.$store.getters["isLoading"];
      return stat;
    },
    items() {
      if (!this.$store) {
        return [];
      }
      var itm = this.$store.getters["sysItems/items"];
      return itm ? itm : [];
    },
    categories() {
      var cats = this.$store.getters["sysItems/categories"];

      return cats ? cats : [];
    },
    backOrderDate() {
      var val = this.selectedItem.backorder_date;
      if (!val) {
        return "";
      }
      var dt = val.length > 0 ? this.selectedItem.backorder_date : null;

      if (!dt) {
        return "";
      }

      return new Date(dt).toISOString().split("T")[0];
    }
  },
  methods: {
    onSelection(e) {
      if (e.data.key) {
        return; //This is a label.
      }

      this.selectedItem = e.data;
    },
    onFilterSelect(e) {
      debugger;
      const dg = this.$refs["grd"].instance;
      if (e === null) {
        //null = All
        dg.clearFilter();
      } else {
        debugger;
        dg.filter(["item_category_id", "=", e]);
      }
    },
    onBlur(field, e) {
      var val = this.validationStat[field];

      if (val) {
        val.state = e.checkValidity();
        val.msg = e.validationMessage;
      }
    },
    categoryDisplay(e) {
      var cat = this.categories.find(c => c.id === e.item_category_id);
      if (!cat) {
        return "";
      }

      if (!cat) {
        return "";
      }

      return cat.name;
    },
    onCellPrep(e) {
      if (
        e.rowType === "data" &&
        e.column.command === "edit" &&
        e.data.is_active === 0
      ) {
        debugger;
        e.cellElement.hidden = true;
      }
    },
    addItem() {
      this.isNewItem = true;
      this.selectedItem = {
        name: "",
        part_number: "",
        item_category_id: null,
        product_code: null,
        is_backordered: 0,
        backorder_date: "",
        is_active: 1
      };
    },
    setBackorder(e) {
      debugger;
      if (!e) {
        this.validationStat.backDate.state = null;
        this.validationStat.backDate.msg = "";
      }
      this.selectedItem.is_backordered = e ? 1 : 0;
    },
    setDate(e) {
      debugger;
      if (!e) {
        this.selectedItem.backorder_date = null;
        return;
      }

      var dt = new Date(e.target.value);

      this.selectedItem.backorder_date = dt;
    },
    showLabel(e) {
      debugger;
      selectedItem.name.length > 0;
    },
    onSubmit(e) {
      e.preventDefault();
      debugger;
      this.submitted = true;
      this.submitting = true;
      //Item Name:
      this.validationStat.name.state = this.$refs.name.checkValidity();
      this.validationStat.name.msg = this.$refs.name.validationMessage;

      //Backorder:
      if (this.selectedItem.is_backordered === 1) {
        this.validationStat.backDate.state = this.$refs.backDate.checkValidity();
        this.validationStat.backDate.msg = this.$refs.backDate.validationMessage;
      }

      if (!e.target.checkValidity()) {
        return;
      }

      var success = this.isNewItem
        ? this.$store.dispatch("sysItems/addItem", this.selectedItem)
        : this.$store.dispatch("sysItems/updateItem", this.selectedItem);

      success.then(rsp => {
        debugger;
        if (!rsp) {
          return;
        }
        this.isNewItem = false;
        this.reset();
      });
    },
    onCancel(e) {
      this.reset();
    },
    onRemovingItem(e) {
      debugger;
      var rsl = this.$store.dispatch("sysItems/removeItem", e.data.id);
      rsl.then(rsp => {
        debugger;
        if (!rsp) {
          e.cancel = true;
          return;
        }

        return;
      });
    },
    reset() {
      //Item Name:
      this.validationStat.name.state = null;
      this.validationStat.name.msg = "";

      //Back order:
      this.validationStat.backDate.state = null;
      this.validationStat.backDate.msg = "";
      debugger;
      this.submitted = false;
      this.submitting = false;
      this.selectedItem = null;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/admin/items.vue